import { render } from "./RequestReset.vue?vue&type=template&id=8e886f0e&scoped=true"
import script from "./RequestReset.vue?vue&type=script&lang=js"
export * from "./RequestReset.vue?vue&type=script&lang=js"

import "./RequestReset.vue?vue&type=style&index=0&id=8e886f0e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e886f0e"]])

export default __exports__